import React from 'react';
import { Link } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars';
import blog_img_1 from "../assets/img/blog/blog-post-1.jpg";
import blog_img_2 from "../assets/img/blog/blog-post-2.jpg";
import blog_img_3 from "../assets/img/blog/blog-post-3.jpg";
import blog_img_4 from "../assets/img/blog/blog-post-4.jpg";
import blog_img_5 from "../assets/img/blog/blog-post-5.jpg";
import blog_img_6 from "../assets/img/blog/blog-post-6.jpg";
const blog_posts = [
    { title: 'How to Own Your Audience by Creating an Email', image: blog_img_1, content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore...' },
    { title: 'Top 10 Toolkits for Deep Learning in 2020', image: blog_img_2, content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore...' },
    { title: 'Everything You Need to Know About Web Accessibility', image: blog_img_3, content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore...' },
    { title: 'How to Inject Humor & Comedy Into Your Brand', image: blog_img_4, content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore...' },
    { title: 'Women in Web Design: How To Achieve Success', image: blog_img_5, content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore...' },
    { title: 'Evergreen versus topical content: An overview', image: blog_img_6, content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore...' },
]
class Blog extends React.Component {
    componentDidMount(){
        document.title = "My Blog - Tunis React Personal Portfolio";
        window.scrollTo(0,0);
    }
    render() {
        return (
            <Scrollbars>
                <div className="blog">
                    <section className="title-section text-left text-sm-center">
                        <h1>my <span>blog</span></h1>
                        <span className="title-bg">posts</span>
                    </section>
                    <section className="main-content">
                        <Container>
                            <Row>
                                {
                                    Object.keys(blog_posts).map((item, i) => (
                                        <Col md={6} lg={6} xl={4} className="mb-30" key={i}>
                                            <article className="post-container">
                                                <div className="post-thumb">
                                                    <Link to={'/blogpost'} className="d-block position-relative overflow-hidden">
                                                        <img src={`${blog_posts[item].image}`} className="img-fluid" alt="Blog Post" />
                                                    </Link>
                                                </div>
                                                <div className="post-content">
                                                    <div className="entry-header">
                                                        <h3>
                                                            <Link to={'/blogpost'}>{ blog_posts[item].title }
                                                            </Link>
                                                        </h3>
                                                    </div>
                                                    <div className="entry-content open-sans-font">
                                                        <p>{ blog_posts[item].content }</p>
                                                    </div>
                                                </div>
                                            </article>
                                        </Col>
                                    ))
                                }
                                <Col xs={12} className="mt-4">
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination justify-content-center mb-0">
                                            <li className="page-item"><a className="page-link" href="#">1</a></li>
                                            <li className="page-item active"><a className="page-link" href="#">2</a></li>
                                            <li className="page-item"><a className="page-link" href="#">3</a></li>
                                            <li className="page-item"><a className="page-link" href="#">4</a></li>
                                        </ul>
                                    </nav>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                </div>
            </Scrollbars>
        )
    }
}

export default Blog